// extracted by mini-css-extract-plugin
module.exports = {"checkboxOverride":"Checkbox_checkboxOverride__vtohY","label":"Checkbox_label__mnl2R","sm":"Checkbox_sm__g8oje"};